import React, { Component } from "react";
import FormContent from "../FormArea/FormContent";

class Form extends Component {
  render() {
    let {
      currentPage,
      formElements
    } = this.props.parentState;
    
    let {printForm }= formElements[currentPage];
    
    return (
      <div className={`${printForm ? "" : "noprint"}`}>
        <FormContent
          parentState={this.props.parentState}
          liftState={this.props.liftState}
          parentProps={this.props.parentProps}
          liftGlobalState={this.props.liftGlobalState}
        />
      </div>
    );
  }
}

export default Form;
